<script setup lang="ts">
import { useI18n } from 'petite-vue-i18n';
import { useLectureStore, useSessionStore } from '../../../stores';
import { Session } from '../../../types/session';
import { TEXT } from '../../../configs/text';
import Heading from '../../General/Heading.vue';
import Fullscreen from '../../General/Fullscreen.vue';
import { computed, ref } from 'vue';
import Iframe from '../../General/Iframe.vue';
import { utils } from '../../../utils';
import Modal from '../../General/Modal.vue';
import { useEventListener } from '@vueuse/core';
import IclassLecture from './iclass/IclassLecture.vue';

const sessionStore = useSessionStore()
const lecture = useLectureStore()
const questionContent = computed<string | undefined>(() => sessionStore.classContent?.[Session.lecture].questionUrl)
const modalShow = ref<boolean>(false)
const url = ref<string>('')

function handleLinkClick(e: MouseEvent) {
    const target = e.target as HTMLElement;
    const anchor = target.closest('a')
    if (!anchor) return;

    e.preventDefault()
    url.value = anchor.getAttribute('href') || ''
    modalShow.value = true
}
useEventListener(document, ['click', 'auxclick'], handleLinkClick)

useEventListener(document, 'contextmenu', (e) => e.preventDefault())

const { t } = useI18n()
</script>

<template>
    <Fullscreen class="p-3 h-full flex flex-col gap-3 items-center">
        <IclassLecture v-if="lecture.questions.length" />
        
        <template v-else-if="questionContent">
            <Heading class="mr-auto mb-0 first-letter:capitalize">{{ t(TEXT.question) }}</Heading>
            <Iframe v-if="utils.isValidUrl(utils.stripHtmlTags(questionContent))"
                :src="utils.stripHtmlTags(questionContent)" orientation="full" />
            <div v-else v-html="questionContent"
                class="prose max-w-none w-full prose-p:my-4 prose-p:leading-6 ck-content border-2 border-gray-200 rounded-lg px-3 md:px-6 overflow-auto">
            </div>
        </template>
    </Fullscreen>
    <Modal v-model="modalShow" size="full" :full-height="true">
        <Iframe v-if="url" :src="url" orientation="full" />
    </Modal>
</template>